import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import user from './slices/userSlice';

// Root reducer
const staticReducers = {
    theme,
    user,
};

const createRootReducer = (asyncReducers = {}) =>
    combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });

export default createRootReducer;